import { __decorate } from "tslib";
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import moment from 'moment';
import { URLS } from '@/common/js/constant/index';
let DialogRedeemVouncher = class DialogRedeemVouncher extends Vue {
    constructor() {
        super(...arguments);
        this.isRedeemLoading = false;
    }
    get formatedVoucherCode() {
        return this.info.voucher_code
            && this.info.voucher_code.replace(/\D/g, '')
                .replace(/(.{4})/g, '$1 ');
    }
    get isToday() {
        return moment().isSame(this.info.participate_time, 'day');
    }
    redeem() {
        this.isRedeemLoading = true;
        this.$ajax.post(URLS.redeemVoucher, {
            voucher_code: this.info.voucher_code,
        }).then((res) => {
            this.$successTips();
            this.$emit('success');
            this.isShowDialog = false;
        }).finally(() => {
            this.isRedeemLoading = false;
        });
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], DialogRedeemVouncher.prototype, "info", void 0);
__decorate([
    PropSync('show', { type: Boolean })
], DialogRedeemVouncher.prototype, "isShowDialog", void 0);
DialogRedeemVouncher = __decorate([
    Component
], DialogRedeemVouncher);
export default DialogRedeemVouncher;
